import { TitleCasePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { DataHeaderAppliedFilter } from '../data-filters/data-header-filter.interface';
import { TableColumnKey } from '../data-table.component';

@Component({
  selector: 'aura-data-chips-filter-header',
  templateUrl: './data-chips-filter-header.component.html',
  imports: [MatMenuModule, MatChipsModule, MatIconModule, TitleCasePipe],
})
export class AuraDataChipsFilterHeaderFilters<K extends string> {
  mappedFilters = input<DataHeaderAppliedFilter<TableColumnKey | K>[]>();
  searchChip = input<string | null>(null);

  removeFilter = output<{ value: string; key: TableColumnKey | K }>();
  triggerSearch = output<null>();
  triggerFiltering = output<null>();

  doRemoveFilter(key: TableColumnKey | K, value: string) {
    this.removeFilter.emit({ key, value });
    this.triggerFiltering.emit(null);
  }
}
